import { AzureDataBricksLinkedService } from './../../linkedservice/azure-data-bricks.linkedservice';
import { AdapterRegistry } from 'app/model/adapters/adapter-registry';
import { Model } from 'app/model/backendmodel';
import { ActivityAsyncAdapter } from './activity.adapter';
import { IModel } from 'app/model/base/annotation';
import { Metamodel } from 'app/model/base/model';
import { ReferenceAdapter } from '../reference.adapter';
import { ValueAdapter } from '../value.adapter';
import _ from 'lodash';
import { SparkPythonActivity } from 'app/model/pipeline/spark-python.activity';
import { databricksParameterToResource, databricksParameterToModel } from 'app/model/pipeline/databricks-parameter.util';
import { databricksLibraryWithExpressionToResource, databricksLibraryWithExpressionToModel, databricksLibraryToModel } from 'app/model/pipeline/databricks-library.util';
import { convertParametersToModel } from 'app/shared/utils/parameter-converter.util';
@AdapterRegistry.adapter({
    model: Metamodel.modelFor(SparkPythonActivity),
    asynchronous: true,
    adapts: {
        name: '*',
        description: '*',
        type: '*',
        linkedServiceName: '*',
        policy: '*',
        dependsOn: '*',
        userProperties: '*',
        typeProperties: {
            pythonFile: '*',
            parameters: '*',
            libraries: '*'
        }
    }
})
export class PythonActivityAdapter extends ActivityAsyncAdapter<SparkPythonActivity, Model.DatabricksPythonActivity> {

    public model(): IModel {
        return Metamodel.modelFor(SparkPythonActivity);
    }

    protected async _toResource(activity: SparkPythonActivity): Promise<Model.DatabricksPythonActivity> {
        const resource: Model.DatabricksPythonActivity = super._getCommonActivityProperties(activity, Metamodel.modelFor(SparkPythonActivity).name) as Model.DatabricksPythonActivity;

        resource.typeProperties = {
            pythonFile: ValueAdapter.toResource(activity, SparkPythonActivity.PYTHON_FILE),
            parameters: databricksParameterToResource(activity.parameters),
            libraries: databricksLibraryWithExpressionToResource(activity.libraries, SparkPythonActivity.LIBRARIES.templateValue(activity))
        };

        if (activity.linkedService) {
            resource.linkedServiceName = this._toLinkedServiceReferenceModel(activity.linkedService, activity.linkedServiceParameters);
        }

        if (activity.raw) {
            const parsed = JSON.parse(activity.raw);
            _.merge(resource, parsed);
        }

        return resource;
    }

    protected async _toModel(modelActivity: Model.DatabricksPythonActivity): Promise<SparkPythonActivity> {
        const activity: SparkPythonActivity = new SparkPythonActivity(modelActivity.name);
        const resource = modelActivity as Model.DatabricksPythonActivity;

        this._updatedCommonProperties(modelActivity, activity);

        if (resource.typeProperties) {
            ValueAdapter.toModel(activity, SparkPythonActivity.PYTHON_FILE, resource.typeProperties.pythonFile);
            activity.parameters = databricksParameterToModel(modelActivity.typeProperties.parameters, activity);
        }

        if (resource.linkedServiceName != null) {
            activity.linkedService = ReferenceAdapter.toProxyModel<AzureDataBricksLinkedService>(Metamodel.modelFor(AzureDataBricksLinkedService),
                resource.linkedServiceName, this.context);
            if (resource.linkedServiceName.parameters) {
                // Parameter value for linked service
                convertParametersToModel(activity,
                    !!this.context.adapterConfig.replaceIdentitiesForNonConcepts,
                    activity.linkedService,
                    activity.linkedServiceParameters,
                    resource.linkedServiceName.parameters);
            }
        }

        if (modelActivity.typeProperties && modelActivity.typeProperties.libraries) {
            databricksLibraryWithExpressionToModel(modelActivity.typeProperties.libraries, SparkPythonActivity.LIBRARIES, activity, () => {
                activity.libraries = databricksLibraryToModel(modelActivity.typeProperties.libraries);
            });
        }

        activity.raw = JSON.stringify(await ValueAdapter.remainder(this.context, resource, SparkPythonActivity.MODEL));

        return activity;
    }
}
